import React from "react";

export default function ({ stroke = "#dddddd", fill = "#6f6f6f" }) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 128 100"
      style={{
        // @ts-ignore It was so before
        enableBackground: "new 0 0 128 100",
      }}
    >
      <circle
        cx="64"
        cy="50"
        r="40"
        fill={fill}
        stroke={stroke}
        strokeMiterlimit={10}
        strokeWidth={6}
      />
    </svg>
  );
}
